import React, { useCallback, useRef, useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { useDismiss } from '../hooks/useDismiss';
import { DropdownOption, DropdownPanel } from './DropdownPanel';
import { TypingCaret } from './TypingCaret';
import { DestinationIcon } from './MenuGlyphs';
type DestinationFieldProps = {
  id: string;
  value: string;
  options: string[];
  onChange: (value: string) => void;
  // Intro typewriter: text being typed in place of the value, and whether the caret shows
  typed?: string | null;
  typing?: boolean;
  onInteract?: () => void;
  invalid?: boolean;
  describedBy?: string;
};

// Lufthansa "From"-style field: small label above, value on a bold underline.
export function DestinationField({
  id,
  value,
  options,
  onChange,
  typed,
  typing,
  onInteract,
  invalid,
  describedBy
}: DestinationFieldProps) {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);
  const close = useCallback(() => setOpen(false), []);
  useDismiss(rootRef, open, close);
  const isTyping = typed !== null && typed !== undefined;
  const shown = isTyping ? typed : value;
  return <div ref={rootRef} className="relative" data-id="element-342" data-mp="ck0iwony2nca">
      <span id={`${id}-label`} className="block text-[12px] font-light text-ink/70" data-id="element-343" data-mp="3uqok43fviqco">
        Destination
      </span>
      <button type="button" id={id} onClick={() => {
      onInteract?.();
      setOpen(o => !o);
    }} aria-haspopup="listbox" aria-expanded={open} aria-labelledby={`${id}-label ${id}`} aria-invalid={invalid || undefined} aria-describedby={describedBy} className={`relative flex h-[44px] w-full items-end border-b-[1.5px] border-ink bg-transparent pb-3 pr-8 text-left text-[18px] focus:outline-none ${shown || isTyping ? 'text-ink' : 'font-light text-ink/60'}`} data-id="element-344" data-mp="2luhe861vj7y">
        <span className="flex min-w-0 items-center truncate" data-id="element-345" data-mp="370kj83u2l4pd">
          {isTyping ? shown : shown || 'Where to?'}
          {typing && <TypingCaret data-id="element-346" data-mp="1clnfzoo2ormp" />}
        </span>
        <ChevronDownIcon className={`pointer-events-none absolute right-0 top-2.5 h-5 w-5 transition-transform duration-300 ease-luxe ${open ? 'rotate-180' : ''}`} strokeWidth={1.25} aria-hidden="true" data-id="element-347" data-mp="1cmouk34arw96" />
      </button>
      <DropdownPanel open={open} data-id="element-348" data-mp="yu8mgnwjh81e">
        <ul role="listbox" aria-labelledby={`${id}-label`} className="max-h-[320px] overflow-y-auto py-2" data-id="element-349" data-mp="yv1t7ovhzxjj">
          {options.map(o => <DropdownOption key={o} label={o} icon={<DestinationIcon city={o} data-id="element-351" data-mp="1mirud2bofisy" />} selected={o === value} onSelect={() => {
          onChange(o);
          setOpen(false);
        }} data-id="element-350" data-mp="1qjv9tnptbctn" />)}
        </ul>
      </DropdownPanel>
    </div>;
}